import React from "react";
import { connect } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";

import { Label, Row, Col, Modal, ModalBody, ModalFooter, ModalHeader, Input } from "reactstrap";
import { getProfileList, selectReportTitles, selectRegisteredUsers } from "./selectors";
import {
    getQualifications,
    addQualification,
    editQualification,
    removeQualification,
    getReportTitles,
    getRegisteredUsers,
    postEditedUser
} from "./actions";
import moment from "moment";
import {
    Typography,
    withStyles,
    Table,
    Button,
    TableBody,
    TableHead,
    TableCell,
    TablePagination,
    TableRow,
    Checkbox,
    FormControlLabel,
    Card,
    CardHeader,
    CardContent
} from "@material-ui/core";

import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";

const styles = theme => ({
    root: {
        width: "100%",
        marginTop: theme.spacing.unit * 3
    },
    tableCell: {
        whiteSpace: "nowrap"
    },
    table: {
        minWidth: 500
    },
    tableWrapper: {
        overflowX: "auto",
        width: "100%;"
    },
    col12: { width: "100%" },
    col9: { width: "75%" },
    col6: { width: "50%" },

    col3: { width: "25%" },
    col2: { width: "16.66%" },
    col1: { width: "8.33%" }
});

class Qualification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            createModal: false,
            editModal: false,
            removeModal: false,
            removeID: false,
            editID: false,
            qualification: {
                qualification_id: "",
                qualification_desc: "",
                qualification_title: "",
                qualification_prefix: "",
                qualification_image_required: true,
                qualification_reg_number_required: false,
                qualification_verification_required: true,
                qualification_expiry_date_required: true
            },
            page: 0,
            rowsPerPage: 25,
            qualificationObj: []
        };
        props.getQualifications();
        props.getReportTitles();
        props.getRegisteredUsers();
    }
    removeFromUser() {
        const { users } = this.props;

        if (typeof users === "undefined") return;
        let userArr = users;
        userArr.map((e, i) => {
            if (typeof e["qualifications"] !== "undefined") {
                e["qualifications"].splice(this.state.removeID, 1);
                this.props.postEditedUser(e, e.uid);
            }
            return true;
        });
    }
    addQualtoUser(qual) {
        const { users } = this.props;
        if (typeof users === "undefined") return;
        let userArr = users;
        userArr.map((e, i) => {
            if (typeof e["qualifications"] === "undefined") e["qualifications"] = [];
            let q = {};

            q["title"] = qual.qualification_title;
            q["expiry_required"] = qual.qualification_expiry_date_required;
            q["verified_required"] = qual.qualification_verification_required;
            q["number_required"] = qual.qualification_reg_number_required;
            q["image_required"] = qual.qualification_image_required;
            if (qual.qualification_image_required) q[`image_url`] = "";
            if (qual.qualification_reg_number_required) q[`number`] = "";
            if (qual.qualification_verification_required) q[`verified`] = "No";
            if (qual.qualification_expiry_date_required) q[`expiry_date`] = "";

            if (e["qualifications"]) e["qualifications"].push(q);
            else e["qualifications"] = [q];
            this.props.postEditedUser(e, e.uid);
            return true;
        });
    }
    checkDate(date) {
        let momentDate = moment(date, "DD/MM/YYYY");
        let currentDate = new moment();
        let futureDate = moment().add(3, "M");
        if (momentDate.isBefore(currentDate)) {
            return "red";
        } else if (momentDate.isAfter(futureDate)) {
            return " #00e600";
        } else {
            return "#ffff00";
        }
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleTableCellsRow = list => {
        return (
            <TableCell
                style={{
                    backgroundColor: list === "No" ? "red" : "white"
                }}
            >
                {list}
            </TableCell>
        );
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    snapshotToArray = snapshot => {
        let returnArr = [];

        snapshot.forEach(childSnapshot => {
            let item = childSnapshot.val();
            item.key = childSnapshot.key;
            returnArr.push(item);
        });

        return returnArr;
    };
    editAllUsers(qual) {
        const { users } = this.props;
        if (typeof users === "undefined") return;
        let userArr = users;
        userArr.map((e, i) => {
            e["qualifications"][this.state.editID]["title"] = qual.qualification_title;
            e["qualifications"][this.state.editID]["expiry_required"] =
                qual.qualification_expiry_date_required;
            e["qualifications"][this.state.editID]["verified_required"] =
                qual.qualification_verification_required;
            e["qualifications"][this.state.editID]["number_required"] =
                qual.qualification_reg_number_required;
            e["qualifications"][this.state.editID]["image_required"] =
                qual.qualification_image_required;
            this.props.postEditedUser(e, e.uid);
            return true;
        });
    }
    render() {
        const { classes } = this.props;
        const { qualification } = this.state;
        const { rowsPerPage, page } = this.state;
        const list = this.props.Qualifications === false ? [] : this.props.Qualifications;
        return (
            <div className={classes.root} style={{ width: "100%" }}>
                <Card className={classes.tableWrapper}>
                    <CardHeader title="Qualification List" />
                    <CardContent>
                        <div>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TablePagination
                                            colSpan={12}
                                            ActionsComponent={TablePaginationHelper}
                                            count={list.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            rowsPerPageOptions={[25, 50]}
                                        />
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className={classes.col1}>
                                            <b>Qualification ID</b>
                                        </TableCell>
                                        <TableCell className={classes.col1}>
                                            <b>Title</b>
                                        </TableCell>
                                        <TableCell className={classes.col2}>
                                            <b>Description</b>
                                        </TableCell>
                                        <TableCell className={classes.col2}>
                                            <b>Image</b>
                                        </TableCell>
                                        <TableCell className={classes.col2}>
                                            <b>Registration No.</b>
                                        </TableCell>
                                        <TableCell className={classes.col2}>
                                            <b>Verification</b>
                                        </TableCell>
                                        <TableCell className={classes.col2}>
                                            <b>Expiry Date</b>
                                        </TableCell>
                                        <TableCell className={classes.col3}>
                                            <b>Actions</b>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.keys(list)
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((e, i) => {
                                            return (
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {list[e].qualification_id}
                                                    </TableCell>
                                                    <TableCell>
                                                        {list[e].qualification_title}
                                                    </TableCell>
                                                    <TableCell>
                                                        {list[e].qualification_desc}
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            background: list[e]
                                                                .qualification_image_required
                                                                ? "Green"
                                                                : "Red"
                                                        }}
                                                    >
                                                        {list[e].qualification_image_required
                                                            ? "Yes"
                                                            : "No"}
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            background: list[e]
                                                                .qualification_reg_number_required
                                                                ? "Green"
                                                                : "Red"
                                                        }}
                                                    >
                                                        {list[e].qualification_reg_number_required
                                                            ? "Yes"
                                                            : "No"}
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            background: list[e]
                                                                .qualification_verification_required
                                                                ? "Green"
                                                                : "Red"
                                                        }}
                                                    >
                                                        {list[e].qualification_verification_required
                                                            ? "Yes"
                                                            : "No"}
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            background: list[e]
                                                                .qualification_expiry_date_required
                                                                ? "Green"
                                                                : "Red"
                                                        }}
                                                    >
                                                        {list[e].qualification_expiry_date_required
                                                            ? "Yes"
                                                            : "No"}
                                                    </TableCell>
                                                    <TableCell
                                                        xs={3}
                                                        style={{
                                                            minWidth: 200
                                                        }}
                                                    >
                                                        <Button
                                                            color="secondary"
                                                            style={{
                                                                border: "1px solid red",
                                                                color: "red",
                                                                margin: 2
                                                            }}
                                                            onClick={() => {
                                                                this.setState({
                                                                    editModal: false,
                                                                    removeModal: true,
                                                                    createModal: false,
                                                                    removeID: e,
                                                                    qualification_id:
                                                                        list[e].qualification_id,
                                                                    qualification_desc:
                                                                        list[e].qualification_desc
                                                                });
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </Button>
                                                        <Button
                                                            color="secondary"
                                                            style={{
                                                                border: "1px solid indigo",
                                                                color: "indigo",
                                                                margin: 2
                                                            }}
                                                            onClick={() => {
                                                                qualification["qualification_id"] =
                                                                    list[e].qualification_id;
                                                                qualification[
                                                                    "qualification_desc"
                                                                ] = list[e].qualification_desc;
                                                                qualification[
                                                                    "qualification_title"
                                                                ] = list[e].qualification_title;
                                                                qualification[
                                                                    "qualification_prefix"
                                                                ] = list[e].qualification_prefix;
                                                                qualification[
                                                                    "qualification_image_required"
                                                                ] =
                                                                    list[
                                                                        e
                                                                    ].qualification_image_required;
                                                                qualification[
                                                                    "qualification_reg_number_required"
                                                                ] =
                                                                    list[
                                                                        e
                                                                    ].qualification_reg_number_required;
                                                                qualification[
                                                                    "qualification_verification_required"
                                                                ] =
                                                                    list[
                                                                        e
                                                                    ].qualification_verification_required;
                                                                qualification[
                                                                    "qualification_expiry_date_required"
                                                                ] =
                                                                    list[
                                                                        e
                                                                    ].qualification_expiry_date_required;
                                                                this.setState({
                                                                    qualification
                                                                });

                                                                this.setState({
                                                                    editModal: true,
                                                                    removeModal: false,
                                                                    createModal: false,
                                                                    editID: e
                                                                });
                                                            }}
                                                        >
                                                            Edit
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </div>

                        <Button
                            color="primary"
                            style={{ marginTop: "10px" }}
                            onClick={() => {
                                this.setState({
                                    editModal: false,
                                    removeModal: false,
                                    createModal: true
                                });
                                qualification["qualification_id"] = "";
                                qualification["qualification_desc"] = "";
                                qualification["qualification_title"] = "";
                                qualification["qualification_prefix"] = "";
                                qualification["qualification_image_required"] = true;
                                qualification["qualification_reg_number_required"] = false;
                                qualification["qualification_verification_required"] = true;
                                qualification["qualification_expiry_date_required"] = true;
                                this.setState({ qualification });
                            }}
                        >
                            Add
                        </Button>
                    </CardContent>
                </Card>
                <Modal isOpen={this.state.editModal}>
                    <ModalHeader>Edit Qualification</ModalHeader>
                    <ModalBody>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <Label for="title">Title</Label>

                                <Input
                                    id="title"
                                    value={qualification["qualification_title"]}
                                    onChange={e => {
                                        qualification["qualification_title"] = e.target.value;
                                        this.setState({ qualification });
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <Label for="description">Description</Label>

                                <Input
                                    id="description"
                                    value={qualification["qualification_desc"]}
                                    onChange={e => {
                                        qualification["qualification_desc"] = e.target.value;
                                        this.setState({ qualification });
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={qualification["qualification_image_required"]}
                                            onChange={event => {
                                                qualification["qualification_image_required"] =
                                                    event.target.checked;
                                                this.setState({
                                                    qualification
                                                });
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label="Is an image of certificate required?"
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={
                                                qualification["qualification_reg_number_required"]
                                            }
                                            onChange={event => {
                                                qualification["qualification_reg_number_required"] =
                                                    event.target.checked;
                                                this.setState({
                                                    qualification
                                                });
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label="Is a certificate registration number required?"
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={
                                                qualification["qualification_verification_required"]
                                            }
                                            onChange={event => {
                                                qualification[
                                                    "qualification_verification_required"
                                                ] = event.target.checked;
                                                this.setState({
                                                    qualification
                                                });
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label="Is a verification required?"
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={
                                                qualification["qualification_expiry_date_required"]
                                            }
                                            onChange={event => {
                                                qualification[
                                                    "qualification_expiry_date_required"
                                                ] = event.target.checked;
                                                this.setState({
                                                    qualification
                                                });
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label="Is a expiration date required?"
                                />
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            onClick={() => {
                                let prefix = this.state.qualification.qualification_title;

                                prefix = prefix.toLowerCase() + "_";
                                prefix = prefix.replace(/ /g, "_");
                                let qual = this.state.qualification;
                                qual["qualification_prefix"] = prefix;
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false,
                                    qualification: qual
                                });
                                this.props.editQualification(
                                    qualification["qualification_id"],
                                    qualification
                                );
                                this.editAllUsers(qual);
                                this.setState({
                                    qualification: []
                                });
                            }}
                        >
                            Submit
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.createModal}>
                    <ModalHeader>Add Qualification</ModalHeader>
                    <ModalBody>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <Label for="title">Title</Label>

                                <Input
                                    id="title"
                                    value={qualification["qualification_title"]}
                                    onChange={e => {
                                        qualification["qualification_title"] = e.target.value;
                                        this.setState({ qualification });
                                    }}
                                />
                            </Col>
                            <Col>
                                <Label for="description">Description</Label>

                                <Input
                                    id="description"
                                    value={qualification["qualification_desc"]}
                                    onChange={e => {
                                        qualification["qualification_desc"] = e.target.value;
                                        this.setState({ qualification });
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={qualification["qualification_image_required"]}
                                            onChange={event => {
                                                qualification["qualification_image_required"] =
                                                    event.target.checked;
                                                this.setState({
                                                    qualification
                                                });
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label="Is an image of certificate required?"
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={
                                                qualification["qualification_reg_number_required"]
                                            }
                                            onChange={event => {
                                                qualification["qualification_reg_number_required"] =
                                                    event.target.checked;
                                                this.setState({
                                                    qualification
                                                });
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label="Is a certificate registration number required?"
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={
                                                qualification["qualification_verification_required"]
                                            }
                                            onChange={event => {
                                                qualification[
                                                    "qualification_verification_required"
                                                ] = event.target.checked;
                                                this.setState({
                                                    qualification
                                                });
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label="Is a verification required?"
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={
                                                qualification["qualification_expiry_date_required"]
                                            }
                                            onChange={event => {
                                                qualification[
                                                    "qualification_expiry_date_required"
                                                ] = event.target.checked;
                                                this.setState({
                                                    qualification
                                                });
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label="Is a expiration date required?"
                                />
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });
                                this.props.addQualification(this.state.qualification);

                                this.addQualtoUser(this.state.qualification);
                            }}
                        >
                            Submit
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.removeModal}>
                    <ModalHeader>Remove Qualification</ModalHeader>
                    <ModalBody>
                        <Typography>
                            Are you sure you want to remove this Job Qualification?
                        </Typography>
                        <Row>
                            <Col>
                                <Label>Qualification Title</Label>

                                <p>
                                    <b>{this.state.qualification_title}</b>
                                </p>
                            </Col>
                            <Col>
                                <Label>Qualification Description</Label>
                                <p>
                                    <b>{this.state.qualification_desc}</b>
                                </p>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            onClick={() => {
                                this.setState({
                                    createModal: false,
                                    removeModal: false,
                                    editModal: false
                                });
                                this.props.removeQualification(this.state.qualification_id);
                                this.removeFromUser();
                                this.setState({ qualification_id: "" });
                            }}
                        >
                            Remove
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default connect(
    store => {
        return {
            reportTitles: selectReportTitles(store),
            Qualifications: getProfileList(store),
            users: selectRegisteredUsers(store)
        };
    },
    {
        postEditedUser,
        getRegisteredUsers,
        getQualifications,
        addQualification,
        editQualification,
        removeQualification,
        getReportTitles
    }
)(withStyles(styles)(Qualification));
